module.exports = __webpack_public_path__ + "static/media/location.f18466ab.jpg";